<div class="account-history-container">
  <!-- Loading spinner -->
  <div class="loading-container" *ngIf="loading">
    <mat-spinner [diameter]="50" color="primary"></mat-spinner>
  </div>

  <!-- Main content when loaded -->
  <ng-container *ngIf="!loading">
    <!-- Header section with title and action buttons -->
    <div class="account-header">
      <div class="header-content">
        <button mat-icon-button (click)="gotoDashboard()" aria-label="Go back to dashboard" class="back-button">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1>Your Account</h1>
      </div>     
      <div class="search-container" *ngIf="hasAccountHistory">
        <mat-form-field appearance="outline">
          <mat-label>Search Transactions</mat-label>
          <input matInput [formControl]="searchControl" placeholder="Search by date or description">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <!-- Balance summary section -->
    <div class="balance-summary" *ngIf="hasAccountHistory">
      <div class="balance-card primary-balance">
        <div class="balance-title">Your Current Balance</div>
        <div class="balance-amount">{{ accountAgingBalance.PatEstBal | currency }}</div>
        <button *ngIf="accountAgingBalance?.Total > 0" mat-raised-button class="pay-button" (click)="submitPaymentForm()">
          <mat-icon>payment</mat-icon> Pay Now
        </button>
      </div>
      
      <div class="balance-details">
        <div class="balance-item">
          <span class="label">Total Charges</span>
          <span class="value">{{ accountAgingBalance.Total | currency }}</span>
        </div>
        <div class="balance-item">
          <span class="label">Insurance Coverage (Est.)</span>
          <span class="value">{{ accountAgingBalance.InsEst | currency }}</span>
        </div>
        <div class="balance-item">
          <span class="label">Your Responsibility</span>
          <span class="value highlight">{{ accountAgingBalance.PatEstBal | currency }}</span>
        </div>
      </div>
    </div>

    <!-- Transaction history section -->
    <div class="transactions-section" id="statement-container" *ngIf="hasAccountHistory">
      <div class="section-header">
        <h2>Visit History</h2>
        <button mat-stroked-button class="download-button" (click)="generatePdf()">
          <mat-icon>download</mat-icon> Download Statement
        </button>
      </div>

      <!-- Mobile-optimized transaction view -->
      <div class="date-grouped-transactions">
        <mat-expansion-panel *ngFor="let group of groupedTransactions" class="date-group" expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ formatDateForDisplay(group.date) }}
            </mat-panel-title>
            <mat-panel-description>
              <span class="day-total" 
                [ngClass]="{'charge': group.dailyChargesTotal > group.dailyPaymentsTotal, 'credit': group.dailyChargesTotal <= group.dailyPaymentsTotal}">
                {{ (group.dailyChargesTotal - group.dailyPaymentsTotal) | currency }}
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          
          <!-- Mobile-optimized table -->
          <div class="mobile-transactions">
            <div *ngFor="let transaction of group.allTransactions" 
                 class="transaction-item"
                 [ngClass]="{'charge-bg': transaction.transactionType === 'Charge', 'credit-bg': transaction.transactionType === 'Credit'}">
              
              <div class="transaction-main">
                <div class="transaction-service">{{ getServiceDescription(transaction.code) }}</div>
                <div class="transaction-amount" [ngClass]="{'charge': transaction.transactionType === 'Charge', 'credit': transaction.transactionType === 'Credit'}">
                  {{ transaction.transactionType === 'Charge' ? (transaction.charge | currency) : (transaction.credit | currency) }}
                </div>
              </div>
              
              <div class="transaction-category" [ngClass]="{
                'adjustment-color': transaction.transactionSource === 'adjustment',
                'insurance-color': transaction.transactionSource === 'insurance',
                'payment-color': transaction.transactionSource === 'payment'
              }">
                {{ getSourceLabel(transaction.transactionSource) }}
              </div>
            </div>
          </div>
          
          <!-- Desktop table (only shown on larger screens) -->
          <div class="desktop-table-container">
            <table class="transaction-table">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Category</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let transaction of group.allTransactions" 
                    [ngClass]="{'charge-row': transaction.transactionType === 'Charge', 'credit-row': transaction.transactionType === 'Credit'}">
                  <td>{{ getServiceDescription(transaction.code) }}</td>
                  <td class="source-cell" [ngClass]="{
                    'adjustment-color': transaction.transactionSource === 'adjustment',
                    'insurance-color': transaction.transactionSource === 'insurance',
                    'payment-color': transaction.transactionSource === 'payment'
                  }">
                    {{ getSourceLabel(transaction.transactionSource) }}
                  </td>
                  <td [ngClass]="{'charge': transaction.transactionType === 'Charge', 'credit': transaction.transactionType === 'Credit'}">
                    {{ transaction.transactionType === 'Charge' ? (transaction.charge | currency) : (transaction.credit | currency) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-expansion-panel>
      </div>

      <!-- Payment action button -->
      <div class="sticky-action">
        <button mat-raised-button class="pay-button" (click)="submitPaymentForm()">
          <mat-icon>payment</mat-icon> Pay My Balance
        </button>        
      </div>
    </div>

    <!-- No transactions message -->
    <div class="no-transactions" *ngIf="!hasAccountHistory">
      <mat-icon class="info-icon">event_note</mat-icon>
      <h2>No Recent Visit History</h2>
      <p>You don't have any recent visits or charges in your account.</p>
    </div>
  </ng-container>
</div>

